import { render, staticRenderFns } from "./PackagePaymentXCoinsModal.vue?vue&type=template&id=2b1b8135&scoped=true"
import script from "./PackagePaymentXCoinsModal.vue?vue&type=script&lang=ts"
export * from "./PackagePaymentXCoinsModal.vue?vue&type=script&lang=ts"
import style0 from "./PackagePaymentXCoinsModal.vue?vue&type=style&index=0&id=2b1b8135&prod&scoped=true&lang=css"
import style1 from "./PackagePaymentXCoinsModal.vue?vue&type=style&index=1&id=2b1b8135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b8135",
  null
  
)

export default component.exports